import { combineReducers } from 'redux';

import apiError from 'modules/global/reducers/generic.error';
import loadingReducer from 'modules/global/reducers/generic.loading';
import { FETCH_INTERVENTION_LINK_REQUEST, FETCH_INTERVENTION_LINK_SUCCESS, RESET_INTERVENTION_LINK_REQUEST } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: boolean,
 *   apiError: string,
 *   link: string,
 * }} InterventionUIDetailsShareReducer
 */

export default combineReducers({
  loading: loadingReducer(FETCH_INTERVENTION_LINK_REQUEST),
  apiError: apiError(FETCH_INTERVENTION_LINK_REQUEST),
  link: createReducer(null, {
    [FETCH_INTERVENTION_LINK_REQUEST]: () => null,
    [RESET_INTERVENTION_LINK_REQUEST]: () => null,
    [FETCH_INTERVENTION_LINK_SUCCESS]: (_, { payload: link }) => link,
  }),
});
